import { useQuery } from "@tanstack/react-query";
import { getStatusesByTrackStage } from "../../api/property-stage";

export const useStatusesByTrackStage = (
  trackStageId?: number,
  rentalTag?: string
) => {
  const query = useQuery({
    queryKey: ["statuses", trackStageId, rentalTag],
    queryFn: () => {
      if (!trackStageId) return undefined;
      return getStatusesByTrackStage(trackStageId, rentalTag);
    },
    enabled: !!trackStageId,
  });

  return {
    ...query,
    data: query.data?.data,
  };
};
